import React from 'react';
import './workStatAll.css';
import { useTranslation } from 'react-i18next';
import { formatStatCardFooterDate } from '../../../../../../utils/timeUtils';



const WorkStatAll = ({ employeeWorkDetails, project }) => {

    const {t} = useTranslation();


    //console.log("employee all data", employeeWorkDetails);

    // Calculate total worked hours and minutes
    let totalMinutes = employeeWorkDetails.reduce((total, detail) => {
        if (detail.work_duration && typeof detail.work_duration === 'string') {
            const durationParts = detail.work_duration.split(':');
            if (durationParts.length === 3) {
                const hours = parseInt(durationParts[0], 10) || 0;
                const minutes = parseInt(durationParts[1], 10) || 0;
                total += hours * 60 + minutes;
            }
        }
        return total;
    }, 0);

    const totalHours = Math.floor(totalMinutes / 60);
    const totalRemainingMinutes = totalMinutes % 60;

    const startDateFormatted = formatStatCardFooterDate(project.startDate);
    const endDateFormatted = formatStatCardFooterDate(project.endDate);

    return (
        <div className='WorkStat-body'>
            <div className='WorkStat-worked-headerbody'>
                <div className='WorkStat-worked-header'>
                    <span>{t("projectDetails_totalWorking")}</span>
                </div>
            </div>
            <div className='WorkStat-worked-duration'>
                {totalHours} Hrs {totalRemainingMinutes} Mins
            </div>
            <div className='WorkStat-worked-footer'>
                {startDateFormatted} - {endDateFormatted}
            </div>
        </div>
    );
};

export default WorkStatAll;
